import buttonStyleDecorator from './buttonStyleDecorator';
import buttonDefaultStyle from './buttonDefaultStyle';
import buttonSizeDecorator from './buttonSizeDecorator';
import buttonDisabledDecorator from './buttonsDisabledDecorator';
import iconButtonSizeDecorator from './iconButtonSizeDecorator';
export const buttonStyleBuilder = (buttonStyle, size, disabled, isIconButton, theme, isLoading) => {
  let style = buttonDefaultStyle(theme);
  style = buttonStyleDecorator(buttonStyle, style, theme, isLoading);
  style = isIconButton ? iconButtonSizeDecorator(size, style, theme) : buttonSizeDecorator(size, style, theme, buttonStyle);
  style = buttonDisabledDecorator(disabled, style, theme, buttonStyle);
  return style;
};